/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="./solr_search_args.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class DealerwareSolrSearch implements IDealerwareSolrSearch{
        //properties
        public static $inject: string[] = ['$q'];
        public searchResults : any;
        public searchArgs : IDealerwareSolrSearchArgs;

        // Constructor
        constructor(public $q : any,public $timeout : any) {
            this.searchArgs     = new DealerwareSolrSearchArgs();
        }

        // Accessors

        // Methods
        public search(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            this.$timeout(function() {_deferred.reject({data: {message: "Can't search from this class just yet"}})});
            return _deferred.promise;
        }

        public autoCompleteSearch(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            this.$timeout(function() {_deferred.reject({data: {message: "Can't search from this class just yet"}})});
            return _deferred.promise;
        }

        public clearResults() : void {
            this.searchResults = undefined;
        }
    }

    getDealerwareWebServicesModule().service("dealerwareSolrSearch", DealerwareSolrSearch);
}